import { ComboModel } from '../components/combo/combo-model';
import { JournalType } from '../enums/journal-type.enum';
import { SortHelper } from '../helpers/sort-helper';

export class JournalTypeHelper {
  public static buildOptions(): ComboModel[] {
    const options = new Array<ComboModel>();
    options.push(this.convertToComboModel(JournalType.AccountStatement)!);
    options.push(this.convertToComboModel(JournalType.Sales)!);
    options.push(this.convertToComboModel(JournalType.Taxes)!);
    options.push(this.convertToComboModel(JournalType.Cash)!);
    options.push(this.convertToComboModel(JournalType.MiscellaneousOperations)!);
    options.push(this.convertToComboModel(JournalType.All)!);
    options.sort(SortHelper.sortByLabelAlphabetically);
    return options;
  }

  public static convertToComboModel(enumValue: JournalType): ComboModel | null {
    if (Object.values(JournalType).includes(enumValue)) {
      const comboModel = new ComboModel();
      comboModel.key = enumValue.valueOf().toString();
      comboModel.label = this.translateEnum(enumValue);
      return comboModel;
    } else {
      return null;
    }
  }

  public static convertToEnum(comboModel: ComboModel): JournalType | undefined {
    if (comboModel) {
      if (comboModel.key === JournalType.Cash.valueOf().toString()) {
        return JournalType.Cash;
      } else if (comboModel.key === JournalType.MiscellaneousOperations.valueOf().toString()) {
        return JournalType.MiscellaneousOperations;
      } else if (comboModel.key === JournalType.Sales.valueOf().toString()) {
        return JournalType.Sales;
      } else if (comboModel.key === JournalType.Taxes.valueOf().toString()) {
        return JournalType.Taxes;
      } else if (comboModel.key === JournalType.All.valueOf().toString()) {
        return JournalType.All;
      }
    }

    return undefined;
  }

  public static translateEnum(enumValue: JournalType): string | undefined {
    if (enumValue === JournalType.Cash) {
      return 'Journal de trésorerie';
    } else if (enumValue === JournalType.MiscellaneousOperations) {
      return 'Journal des OD';
    } else if (enumValue === JournalType.Sales) {
      return 'Journal des ventes';
    } else if (enumValue === JournalType.Taxes) {
      return 'Journal des taxes';
    } else if (enumValue === JournalType.All) {
      return 'Export comptable global';
    } else if (enumValue === JournalType.AccountStatement) {
      return 'Extrait de compte client';
    }
    return undefined;
  }
}
